module.exports = __webpack_public_path__ + "img/new-kpi-logo.c4f49ce2.svg";